import {
  IHandleNewsletterSubscribeParams,
  IHandleNewsletterUnsubscribeParams,
  INewsletterSubscribeResponse,
  INewsletterUnsubscribeResponse,
} from "@model/Home.model";
import { AxiosCalls } from "./Functions/AxiosCalls";
import { handleDefaultApiErrors } from "Utils/Global/apiErrorHandling";

export class NewsletterService {
  async handleSubscribe({
    email,
    setLoading,
    setApiError,
  }: IHandleNewsletterSubscribeParams): Promise<string | null> {
    setLoading(true);
    setApiError(null);

    try {
      const resp = await AxiosCalls.Post<
        INewsletterSubscribeResponse,
        { email: string }
      >("/newsletter/subscribe", { email });

      return resp?.data?.message ?? "Subscribed successfully.";
    } catch (err) {
      const msg = handleDefaultApiErrors(err);
      setApiError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  }

  async handleUnsubscribe({
    email,
    setLoading,
    setApiError,
    setSuccessMsg,
  }: IHandleNewsletterUnsubscribeParams): Promise<void> {
    setLoading(true);
    setApiError(null);
    setSuccessMsg(null);

    try {
      const rawParam = String(email ?? "").trim();
      if (!rawParam) throw new Error("Email cannot be empty");
      email = rawParam.includes("%") ? decodeURIComponent(rawParam) : rawParam;

      const resp = await AxiosCalls.Delete<INewsletterUnsubscribeResponse>(
        `/newsletter/unsubscribe?email=${encodeURIComponent(email)}`
      );

      setSuccessMsg(
        resp?.data?.message ??
          "We’re sad to see you go, but you’re always welcome back. You have been unsubscribed from the ChimeraTech newsletter."
      );
    } catch (err) {
      const msg = handleDefaultApiErrors(err, { hadToken: false });
      setApiError(msg);
    } finally {
      setLoading(false);
    }
  }
}
